export default __webpack_public_path__ + "static/media/swap-xs.67404932.svg";